<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="likeName"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="initData" type="primary" @click="initData">
          {{ $t('CargoMsg.Cargo_InitData') }}
        </el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{
          $t('common.btn.query')
        }}
        </el-button>
        <el-button no="add" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="update" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="101361-agGrid"
        config-module="101361"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        no="101361-pagination"
        config-module="101361"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_Code') }}</span>
            <el-input v-model="editDialog.form.code" no="code" oninput="value=value.replace(/[^\w_]/g,'');" :maxlength="10" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_ChineseName') }}</span>
            <el-input v-model="editDialog.form.chineseName" no="chineseName" :maxlength="50" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_EnglishName') }}</span>
            <el-input v-model="editDialog.form.englishName" no="englishName" :maxlength="50" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_ServiceType') }}</span>
            <el-checkbox v-model="editDialog.form.typeKh" no="typeKh">{{ $t('CargoMsg.Cargo_TypeKh') }}</el-checkbox>
            <el-checkbox v-model="editDialog.form.typeTc" no="typeTc">{{ $t('CargoMsg.Cargo_TypeTc') }}</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  addVehicleModel,
  deleteVehicleModel,
  initVehicleModel,
  listVehicleModel,
  updateVehicleModel
} from '@/api/basicData/vehicleModel'

export default {
  name: 'VehicleModel',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceType'),
          field: 'serviceType',
          width: 200,
          valueFormatter: (params) => {
            const arr = []
            const data = params.data
            if (data.typeKh) arr.push(this.$t('CargoMsg.Cargo_TypeKh'))
            if (data.typeTc) arr.push(this.$t('CargoMsg.Cargo_TypeTc'))
            return arr.join(',')
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          typeKh: '',
          typeTc: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (!this.rowData) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      listVehicleModel(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          code: '',
          chineseName: '',
          englishName: '',
          typeKh: '',
          typeTc: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_VehicleModel')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length > 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_VehicleModel')
      }
      this.editDialog.visible = true
    },
    // 保存公用-新增修改
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.codeCheck'))
        return
      }
      if (!form.chineseName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.chineseNameCheck'))
        return
      }
      if (!form.englishName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.englishNameCheck'))
        return
      }
      if (!form.typeKh && !form.typeTc) {
        self.$message.warning(self.$t('CargoMsg.Cargo_ServiceType') + self.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const loading = getLoading()
      if (!form.uuid) {
        self.filter.pageNum = 1
        addVehicleModel(form).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          self.editDialog.visible = false
        }).finally(() => loading.close())
      } else {
        updateVehicleModel(form).then(res => {
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          self.editDialog.visible = false
        }).finally(() => loading.close())
      }
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const loading = getLoading()
      const uuids = Array.from(rows, p => p.uuid)
      deleteVehicleModel(uuids).then(res => {
        if (res.data && Number(res.data) > 0) {
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        }
        self.filter.pageNum = 1
        self.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    },
    initData() {
      if (this.total > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotInitData'))
        return
      }
      const loading = getLoading()
      initVehicleModel().then(res => {
        if (res.data && Number(res.data) > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_InitData') + this.$t('CargoMsg.Cargo_Success'))
        }
        this.filter.pageNum = 1
        this.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    }
  }
}
</script>

